import {Component, OnInit} from '@angular/core';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';
import {TenantConfigService} from '@rsp/shared/services/tenant-config.service';
import {TenantDTO} from '@rsp/models/dto/tenant.dto';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'rsp-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.css']
})

export class ImpressumComponent implements OnInit {

  public tenant: TenantDTO;

  public title: string;
  public icon: string;
  public content: string;

  constructor(private activatedRoute: ActivatedRoute, private tenantConfigService: TenantConfigService, private userTracker: UserTrackingService) {
    this.tenant = this.tenantConfigService.getInfo();

    this.activatedRoute.url.subscribe( (event) => {
      switch (event[0].path) {
        case 'impressum':
          this.title = 'Impressum';
          this.content = this.tenant?.legalNotice;
          this.icon = 'description';
          break;

        case 'datenschutz':
          this.title = 'Datenschutz';
          this.content = this.tenant?.privacyNotice;
          this.icon = 'policy';
          break;

        case 'kontakt':
          this.title = 'Kontakt';
          this.content = this.tenant?.contact;
          this.icon = 'people';
          break;
      }

    });
  }

  ngOnInit() {
    this.userTracker.trackPageView();
  }
}
